import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE,
  messagingSenderId: process.env.REACT_APP_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT,
});

export function getFirebase() {
  return app;
}

// Utilidades para cachear en localStorage con expiración diaria
export function setWithExpiry(key, value) {
  const now = new Date();
  // Guardar el valor y la fecha actual
  const item = {
    value: value,
    expiry: now.setHours(24, 0, 0, 0), // Expira a la medianoche del día siguiente
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      // Expirado
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (e) {
    // Si hay error, limpiar y devolver null
    localStorage.removeItem(key);
    return null;
  }
}

export function getFirestore() {
  console.log("se ejecuta firestore");
  return firebase.firestore(app);
}
